import { resolveCdnUrl } from '../utils/cdnUrl';

const crowdNoiseSrc = resolveCdnUrl('audio/crowd-noise-284490.mp3');
const backgroundCrowdSrc = resolveCdnUrl('audio/generic-crowd-background-noise-31310.mp3');
const oudArabianSrc = resolveCdnUrl('audio/oud-c-arabian-400521.mp3');

export type MusicTrack = {
  id: string;
  label: string;
  src: string;
  volume?: number;
};

export const MUSIC_TRACKS: MusicTrack[] = [
  {
    id: "crowd-noise-284490",
    label: "Crowd Noise",
    src: crowdNoiseSrc,
    volume: 0.55,
  },
  {
    id: "generic-crowd-background-noise-31310",
    label: "Background Crowd",
    src: backgroundCrowdSrc,
    volume: 0.55,
  },
  {
    id: "oud-c-arabian-400521",
    label: "Oud C Arabian",
    src: oudArabianSrc,
    volume: 0.55,
  },
];

export const DEFAULT_MUSIC_TRACK_ID = MUSIC_TRACKS[0]?.id ?? "ambient-prayer";
